export const BACKEND_SERVICE_URL_KEY = 'backendServiceBaseUrl';
